import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import type { TelaDeModulo } from '../contrato.ts';
import { gestao } from './api.ts';
import { textos, idiomaTela, useTextos } from './i18n.ts';
import { Consulta } from './comum.tsx';
import { Conectores } from './conectores.tsx';
import { Webhooks } from './webhooks.tsx';
import { Chaves } from './chaves.tsx';
import './integracoes.css';

function Api() {
  const t = useTextos();
  return <>
    <a href="/api/docs" target="_blank" rel="noreferrer">
      {t.apiDocs}
    </a>
    <Chaves />
  </>;
}

function Mcp() {
  const t = useTextos();
  const [ocultos, setOcultos] = useState<string[]>([]);
  const q = useQuery({
    queryKey: ['integracoes', 'mcp'],
    queryFn: () => gestao<{
      url: string;
      protocolo: string;
      tools: {
        nome: string;
        modulo: string;
        tipo: string;
        descricao: string;
      }[];
      chamadas: {
        tool: string;
        sucesso: boolean;
        latencia_ms: number;
        created_at: string;
      }[];
    }>('mcp_status'),
  });
  const modulos = [...new Set(q.data?.tools.map(t => t.modulo) ?? [])];
  return <div className="integracoes">
    <Consulta consulta={q} vazio={!q.data?.tools.length}>
      <label>
        {t.urlMcp}
        <input readOnly value={q.data?.url ?? ''} />
      </label>
      <p>
        {q.data?.protocolo}
      </p>
      <h2>
        {t.ferramentas}
      </h2>
      <div>
        {modulos.map(m => <label key={m}>
          <input
            type="checkbox"
            checked={!ocultos.includes(
              m,
            )}
            onChange={() => setOcultos(
              xs => xs.includes(
                m,
              )
                ? xs.filter(
                  x => x !== m,
                )
                : [
                  ...xs,
                  m,
                ],
            )}
          />
          {t.mostrar}
          {': '}
          {m}
        </label>)}
      </div>
      <ul>
        {q.data?.tools.filter(x => !ocultos.includes(x.modulo)).map(x => <li key={x.nome}>
          <code>
            {x.nome}
          </code>

          {' ('}
          {x.tipo}
          {')'}
        </li>)}
      </ul>
      <h2>
        {t.chamadas}
      </h2>
      <div className="integracoes__tabela">
        <table>
          <thead>
            <tr>
              <th>
                {'Tool'}
              </th>
              <th>
                {t.estado}
              </th>
              <th>
                {'ms'}
              </th>
            </tr>
          </thead>
          <tbody>
            {q.data?.chamadas.map((c, i) => <tr key={i}>
              <td>
                {c.tool}
              </td>
              <td>
                {c.sucesso ? t.entregue : t.falhou}
              </td>
              <td>
                {c.latencia_ms}
              </td>
            </tr>)}
          </tbody>
        </table>
      </div>
    </Consulta>
    <Chaves mcp />
  </div>;
}

export const tela: TelaDeModulo = {
  slug: 'integracoes',
  rota: '/integracoes',
  get titulo() {
    return textos[idiomaTela()].titulo;
  },
  abas: [
    {
      id: 'conectores',
      get rotulo() {
        return textos[idiomaTela()].conectores;
      },
      conteudo: Conectores,
    },
    {
      id: 'webhooks',
      get rotulo() {
        return textos[idiomaTela()].webhooks;
      },
      conteudo: Webhooks,
    },
    { id: 'api', rotulo: 'API', conteudo: Api },
    { id: 'mcp', rotulo: 'MCP', conteudo: Mcp },
  ],
};
